import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import React from 'react';
import CredencialContainer from './Components/CredencialContainer/CredencialContainer';
import NotFound from './Components/NotFound/NotFound';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/:hash" exact="true" element={<CredencialContainer />} />
        <Route path="/credencial/:hash" exact="true" element={<CredencialContainer />} />
        <Route path="*" element={<NotFound />}/>
        <Route path="/not-found" element={<NotFound />}/>
      </Routes>
    </Router>    
  );
}

export default App;
